export const googleMapsApiKey = process.env.MIX_GOOGLE_MAPS_API_KEY
export const bigDataLocationApiKey = process.env.MIX_BIGDATA_LOCATION_API_KEY

